import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import MailBodyEditorContent from "@pages/email/common/view/MailBodyEditorContent";

const FullMailBodyTemplateTabs = (props) => {
    const [currentTab, setCurrentTab] = useState('strange-candidate-tab');
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [mailContent, setMailContent] = useState({
        strangle_candidate_body: "",
        not_gp_candidate_body: "",
        gp_candidate_body: "",
        email2_instructor_body: "",
    });

    const {content, onChange} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])


    useEffect(() => {
        setMailContent({...content})
    }, [content])

    const onTabClicked = (tabId) => {
        setCurrentTab(tabId);
    };

    const onChangeMailContent = (bodyContent, field) => {
        console.log("FullMailBodyTemplateTabs: onChangeMailContent")
        mailContent[field] = bodyContent
        // setMailContent({...mailContent})
        onChange(mailContent)
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title'><b>Temp BODY EMAIL</b></h3>
                </div>
                <div className='card-body p-0'>
                    <ul className='nav nav-tabs' role='tablist'>
                        <li className='nav-item'>
                            <a className={`nav-link active`} data-toggle='tab' href={"#strange-candidate-tab"}>UV lạ</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link`} data-toggle='tab' href={"#familar-candidate-not-with-gp-tab"}>UV quen chưa gth GP</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link`} data-toggle='tab' href={"#familar-candidate-with-gp-tab"}>UV quen đã gth GP</a>
                        </li>
                        <li className='nav-item'>
                            <a className={`nav-link`} data-toggle='tab' href={"#email2-instructor-for-ad-tab"}>Email 2 - giới thiệu</a>
                        </li>
                    </ul>
                    <div className='tab-content'>
                        <div id={"strange-candidate-tab"} className={`tab-pane active`}
                             style={{maxHeight: '83vh', overflow: 'auto'}}>
                            <MailBodyEditorContent
                                name={"1"}
                                onChange={(values) => onChangeMailContent(values, 'strangle_candidate_body')}
                                content={mailContent.strangle_candidate_body}/>
                        </div>
                        <div id={"familar-candidate-not-with-gp-tab"} className={`tab-pane`}
                             style={{maxHeight: '83vh', overflow: 'auto'}}>
                                <MailBodyEditorContent
                                    name={"2"}
                                onChange={(values) => onChangeMailContent(values, 'not_gp_candidate_body')}
                                content={mailContent.not_gp_candidate_body}/>
                        </div>
                        <div id={"familar-candidate-with-gp-tab"} className={`tab-pane`}
                             style={{maxHeight: '83vh', overflow: 'auto'}}>
                            <MailBodyEditorContent
                                name={"3"}
                                onChange={(values) => onChangeMailContent(values, 'gp_candidate_body')}
                                content={mailContent.gp_candidate_body}/>
                        </div>
                        <div id={"email2-instructor-for-ad-tab"} className={`tab-pane`}
                             style={{maxHeight: '83vh', overflow: 'auto'}}>
                            <MailBodyEditorContent
                                name={"4"}
                                onChange={(values) => onChangeMailContent(values, 'email2_instructor_body')}
                                content={mailContent.email2_instructor_body}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FullMailBodyTemplateTabs;
